import { Injectable } from '@angular/core';
import { APIGatewayService } from '../gateway/APIGateway.service';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {

    private _localStoragePrefix: string;

    constructor(private apiGatewayService: APIGatewayService,) {
        this._localStoragePrefix = this.apiGatewayService.GetAPIURL();
        this.MigrateOldStorage();
    }

    SetItem(key: string, value: string) {
        const prefixedKey = this.GetPrefixedKey(key);
        localStorage.setItem(prefixedKey, value);
    }

    GetItem(key: string): string {
        const prefixedKey = this.GetPrefixedKey(key);
        return localStorage.getItem(prefixedKey);
    }

    RemoveItem(key: string) {
        const prefixedKey = this.GetPrefixedKey(key);
        localStorage.removeItem(prefixedKey);
    }

    Clear() {
        Object.keys(localStorage).forEach((key) => {
            if (key.startsWith(this._localStoragePrefix)) {
                localStorage.removeItem(key);
            }
        });
    }

    private GetPrefixedKey(key: string): string {
        return `${this._localStoragePrefix}${key}`;
    }

    private MigrateOldStorage() {
        if(this.GetItem('migratedOldStorage')) {
            return;
        }

        Object.keys(localStorage).forEach((key) => {
            if (!key.startsWith(this._localStoragePrefix)) {
                const newKey = this.GetPrefixedKey(key);
                const value = localStorage.getItem(key);

                if (value !== null) {
                    localStorage.setItem(newKey, value);
                }
            }
        });

        this.SetItem('migratedOldStorage', 'true');
    }
}
